const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * DISPATCHER EVENTS                                                          *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.dispatcherMarketSelectionSubmitted,
    (payload) => {
      pushEvent(
        createCustomEventGA4('dispatcher', [
          ['action', 'click'],
          ['url', payload.url],
        ])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
